import { Store } from "pullstate";

export const UIStore = new Store({
    questionBank: []
});